import React, { useEffect, useRef } from "react";
// Ensure you import the CSS file above

// --- SVG Icons ---
const Mats = {
    Spool: () => (
        <svg viewBox="0 0 24 24" fill="none" class="mat-icon-svg spool-anim">
            <path d="M12 2C9 2 7 4 7 7V17C7 20 9 22 12 22C15 22 17 20 17 17V7C17 4 15 2 12 2Z" stroke="currentColor" strokeWidth="1.5" />
            <path d="M7 6H17" stroke="currentColor" strokeWidth="1.5" />
            <path d="M7 18H17" stroke="currentColor" strokeWidth="1.5" />
            <path d="M7 9H17" stroke="currentColor" strokeWidth="1" strokeDasharray="3 2" className="thread-lines" />
            <path d="M7 12H17" stroke="currentColor" strokeWidth="1" strokeDasharray="3 2" className="thread-lines" />
            <path d="M7 15H17" stroke="currentColor" strokeWidth="1" strokeDasharray="3 2" className="thread-lines" />
        </svg>
    ),
    Layers: () => (
        <svg viewBox="0 0 24 24" fill="none" class="mat-icon-svg layers-anim">
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.5" />
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.5" />
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    ),
    NeedleHand: () => (
        <svg viewBox="0 0 24 24" fill="none" class="mat-icon-svg needle-anim">
            <path d="M19 3L14 8" stroke="currentColor" strokeWidth="1.5" />
            <line x1="20" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M18 13L13 18C12 19 10 19 9 18L5 14C4 13 4 11 5 10L10 5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M3 21L6 18" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
        </svg>
    ),
    Shield: () => (
        <svg viewBox="0 0 24 24" fill="none" class="mat-icon-svg shield-anim">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="1.5" />
            <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    )
};

const materialsData = [
  {
    id: "01",
    title: "Threads We Use",
    desc: "We select only the finest colorfast threads, chosen for their silken sheen and high tensile strength.",
    Icon: Mats.Spool,
    delay: "0.1s"
  },
  {
    id: "02",
    title: "Fabrics & Bases",
    desc: "From organic cotton canvas to sustainable wooden hoops, our foundations are as durable as they are beautiful.",
    Icon: Mats.Layers,
    delay: "0.2s"
  },
  {
    id: "03",
    title: "Hand vs. Machine",
    desc: "Machines repeat; hands create. Hand embroidery offers depth and texture mass production cannot replicate.",
    Icon: Mats.NeedleHand,
    delay: "0.3s"
  },
  {
    id: "04",
    title: "Our Quality",
    desc: "Every knot is tied with intention. We inspect every inch for neatness, treating your custom piece with respect.",
    Icon: Mats.Shield,
    delay: "0.4s"
  }
];

export default function MaterialsSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mat-visible");
          }
        });
      },
      { threshold: 0.15 } // Trigger when 15% visible
    );

    const title = document.querySelector(".mat-header");
    const cards = document.querySelectorAll(".mat-card");

    if (title) observer.observe(title);
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="mat-section" ref={sectionRef}>
      {/* Background Decor */}
      <div className="mat-bg-decor">
        <svg className="mat-structure struct-1" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
           <circle cx="50" cy="50" r="45" />
           <circle cx="50" cy="50" r="40" strokeDasharray="5 5"/>
        </svg>
        <svg className="mat-structure struct-2" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
           <rect x="20" y="20" width="60" height="60" transform="rotate(45 50 50)" />
        </svg>
      </div>

      <div className="mat-container">
        {/* Header */}
        <div className="mat-header">
          <h2 className="mat-title">
            Materials & <span className="mat-script">Craftsmanship</span>
          </h2>
          <p className="mat-subtitle">
            Great embroidery begins with great materials. We refuse to compromise on the foundation of our art.
          </p>
        </div>

        {/* Card Grid */}
        <div className="mat-grid">
          {materialsData.map((item) => (
            <div 
              key={item.id} 
              className="mat-card"
              style={{ animationDelay: item.delay }}
            >
              <div className="mat-card-number">{item.id}</div>
              
              <div className="mat-icon-box">
                <item.Icon />
              </div>
              
              <h3 className="mat-card-title">{item.title}</h3>
              <p className="mat-card-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}